export const VEHICLE_ENGINE_TYPES = [
  {
    label: 'Gasoline',
    value: 'GASOLINE',
  },
  {
    label: 'Diesel',
    value: 'DIESEL',
  },
  {
    label: 'Biofuel',
    value: 'BIOFUEL',
  },
  {
    label: 'NGV (Natural Gas Vehicle)',
    value: 'NGV',
  },
  {
    label: 'Hybrid',
    value: 'HYBRID',
  },
  {
    label: 'Electric',
    value: 'ELECTRIC',
  },
];

export const VEHICLE_EURO_CATEGORIES = ['0', '1', '2', '3', '4', '5', '6'].map((type) => ({
  label: `Euro ${type}`,
  value: `EURO_${type.toUpperCase()}`,
}));

export const VEHICLE_CONTAINER_LENTH = {
  twentyFeet: 6.09,
  fourtyFeet: 12.2,
  extensible: 13.8,
};
